"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getAlignUtilities = getAlignUtilities;
exports.alignBaseline = alignBaseline;
exports.alignTop = alignTop;
exports.alignMiddle = alignMiddle;
exports.alignBottom = alignBottom;
exports.alignTextBottom = alignTextBottom;
exports.alignTextTop = alignTextTop;
exports.default = void 0;

function getAlignUtilities() {
  return "\n   ".concat(alignBaseline(), "\n   ").concat(alignTop(), "\n   ").concat(alignMiddle(), "\n   ").concat(alignBottom(), "\n   ").concat(alignTextBottom(), "\n   ").concat(alignTextTop(), "\n  ");
}

function alignBaseline() {
  return "\n    .align-baseline { vertical-align: baseline !important; } /* Browser default */\n  ";
}

function alignTop() {
  return "\n    .align-top { vertical-align: top !important; }\n  ";
}

function alignMiddle() {
  return "\n    .align-middle { vertical-align: middle !important; }\n  ";
}

function alignBottom() {
  return "\n    .align-bottom { vertical-align: bottom !important; }\n  ";
}

function alignTextBottom() {
  return "\n    .align-text-bottom { vertical-align: text-bottom !important; }\n  ";
}

function alignTextTop() {
  return "\n    .align-text-top { vertical-align: text-top !important; }\n  ";
}

var _default = {
  getAlignUtilities: getAlignUtilities,
  alignBaseline: alignBaseline,
  alignTop: alignTop,
  alignMiddle: alignMiddle,
  alignBottom: alignBottom,
  alignTextBottom: alignTextBottom,
  alignTextTop: alignTextTop
};
exports.default = _default;


//////////////////
// WEBPACK FOOTER
// ./node_modules/@bootstrap-styled/css-utils/lib/align.js
// module id = 117
// module chunks = 0